<div class="d-flex justify-content-center align-items-center vh-100">
    <div class="text-center">
      <h1 class="display-4">Page Not Found</h1>
      <p class="lead">Sorry, the specified page does not exist.</p>
      <a routerLink="/" class="btn btn-primary">Go to Home Page</a>
    </div>
  </div>
  